import { render } from "./CustomerChangePassword.vue?vue&type=template&id=16d57894&scoped=true"
import script from "./CustomerChangePassword.vue?vue&type=script&lang=js"
export * from "./CustomerChangePassword.vue?vue&type=script&lang=js"

import "./CustomerChangePassword.vue?vue&type=style&index=0&id=16d57894&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d57894"]])

export default __exports__